/**
 * Today's gateways as a table: the header row and one GatewayRow per
 * gateway, the busiest first; scrolls sideways only on a narrow screen.
 * No "Sends for" column since 23/10/2026 (client QA: "Not required").
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import type { GatewayToday } from '../gateways-today';
import { GatewayRow, GRID } from './GatewayRow';

const H = 'text-[10px] font-semibold uppercase tracking-wider text-muted-foreground';

export const GatewaysTable: FC<{ gateways: GatewayToday[] }> = ({ gateways }) => (
  <div className="overflow-x-auto">
    <div className="min-w-[860px]">
      <div className={`${GRID} border-b border-border/60 py-2 ${H}`}>
        <span>Gateway</span>
        <span className="text-right">Drops</span>
        <span className="text-right">SMS</span>
        <span className="text-right">Delivered</span>
        <span className="text-right">Bot</span>
        <span className="text-right">CR</span>
        <span className="text-right">$ / SMS</span>
        <span className="text-right">Est. $</span>
        <span className="text-right">Status</span>
      </div>
      {gateways.map((g) => (
        <GatewayRow key={g.routeId} gateway={g} />
      ))}
    </div>
  </div>
);
